export class CourseCatalogueConstants {
    public static readonly CourseSearch_Place_Holder_Text: string =
        'Search by Number, Name, Legacy Number or Description';
    // features
    public static readonly Course_Feature: string = 'course';

     //Filter labels
  
  public static readonly Course_Search_Text: string = "searchText";  
  public static readonly Course_Search_Status_Text: string = "status";
  public static readonly Course_Search_Format_Text: string = "format";

    // Toaster Messages and Severity
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Err: string = 'error';
    public static readonly Severity_Warning: string = 'warn';
    public static readonly CourseSearchEmpty_Filters:string=
    'At least one search criterion must be defined';

    public static readonly CourseSearch_Error_Message: string = "An error occurred during the course search.";
}
